import * as _ from "lodash";

export function keyForIds(ids: Array<string>): string {
    return (
        _.reduce(ids, (total, n) => {
            const a = String(n);
            return total + parseInt(a.replace(/\D/g, ""), 10);
        }) || ""
    );
}
